import { defineComponent, ref, onMounted, onBeforeUnmount, inject, computed, watch, resolveComponent, openBlock, createBlock, withCtx, createVNode, normalizeProps, guardReactiveProps, mergeProps, createTextVNode, renderSlot, createElementBlock, Fragment, createCommentVNode, toDisplayString } from "vue";
import { u as useDefaults, _ as _export_sfc } from "../_plugin-vue_export-helper-3194dc60.mjs";
import { M as MalarkeyContactAvatar } from "../MalarkeyContactAvatar-1b079ba3.mjs";
import "../index-fd2245c5.mjs";
import "../_commonjsHelpers-ca272635.mjs";
import "../_density-8094aebe.mjs";
const _sfc_main = defineComponent({
  name: "MalarkeyToolbarUserMenu",
  components: {
    MalarkeyContactAvatar
  },
  emits: [
    /**
     * Emitted when the user clicks the login button.
     */
    "click:login"
  ],
  props: {
    /**
     * Specifies whether to show the login button.
     */
    showLogin: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const appMounted = ref(false);
    onMounted(() => {
      appMounted.value = true;
    });
    onBeforeUnmount(() => {
      appMounted.value = false;
    });
    const identity = inject("identity");
    const btnDefaults = useDefaults({}, "VBtn");
    const menuBtnDefaults = useDefaults(
      btnDefaults,
      "MalarkeyToolbarUserMenuMenuBtn"
    );
    const authenticated = computed(
      () => identity ? identity.authenticated.value : false
    );
    const menuBtnBindings = computed(() => ({
      ...menuBtnDefaults,
      loading: !identity || identity.authenticated.value && !identity.identified.value,
      disabled: !appMounted.value || !identity,
      icon: authenticated.value ? true : "mdi-account-off"
    }));
    const avatarBindings = computed(() => ({
      identity: identity && identity.authenticated.value ? identity.user.value.id : void 0
    }));
    const usernameListItemBindings = computed(() => ({
      title: identity && identity.authenticated.value ? identity.user.value.username : void 0
    }));
    const showLogin = computed(() => props.showLogin);
    const menu = ref(false);
    const login = (e) => {
      e.preventDefault();
      emit("click:login");
    };
    const logout = (e) => {
      e.preventDefault();
      if (identity) {
        identity.logout();
      }
    };
    watch(
      () => menu.value,
      (is) => {
        if (is && !authenticated.value && !showLogin.value) {
          menu.value = false;
        }
      },
      { immediate: true }
    );
    return {
      authenticated,
      menuBtnBindings,
      avatarBindings,
      usernameListItemBindings,
      login,
      logout,
      showLogin,
      menu
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MalarkeyContactAvatar = resolveComponent("MalarkeyContactAvatar");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_list_item_title = resolveComponent("v-list-item-title");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_menu = resolveComponent("v-menu");
  return openBlock(), createBlock(_component_v_menu, {
    modelValue: _ctx.menu,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.menu = $event)
  }, {
    activator: withCtx(({ props }) => [
      createVNode(_component_v_btn, normalizeProps(guardReactiveProps({ ..._ctx.menuBtnBindings, ...props })), {
        default: withCtx(() => [
          _ctx.authenticated ? (openBlock(), createBlock(_component_MalarkeyContactAvatar, normalizeProps(mergeProps({ key: 0 }, _ctx.avatarBindings)), null, 16)) : (openBlock(), createBlock(_component_v_icon, { key: 1 }, {
            default: withCtx(() => [
              createTextVNode("mdi-account-off")
            ]),
            _: 1
          }))
        ]),
        _: 2
      }, 1040)
    ]),
    default: withCtx(() => [
      createVNode(_component_v_card, {
        width: "200",
        style: { "overflow-x": "hidden", "overflow-y": "hidden" }
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "prepend", { authenticated: _ctx.authenticated }),
          !_ctx.authenticated ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            _ctx.showLogin ? (openBlock(), createBlock(_component_v_list_item, {
              key: 0,
              title: _ctx.$t("malarkeyLogin.general.login"),
              onClick: _cache[0] || (_cache[0] = ($event) => (
                // @ts-ignore
                ($e) => _ctx.login($e)
              ))
            }, null, 8, ["title"])) : createCommentVNode("", true)
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createVNode(_component_v_list_item, null, {
              default: withCtx(() => [
                createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.usernameListItemBindings.title), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            createVNode(_component_v_divider),
            renderSlot(_ctx.$slots, "in-between", { authenticated: _ctx.authenticated }),
            createVNode(_component_v_list_item, {
              title: _ctx.$t("general.logout"),
              onClick: _ctx.logout
            }, null, 8, ["title", "onClick"])
          ], 64)),
          renderSlot(_ctx.$slots, "append", { authenticated: _ctx.authenticated })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue"]);
}
const MalarkeyToolbarUserMenu = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "MalarkeyToolbarUserMenu.vue"]]);
export {
  MalarkeyToolbarUserMenu as default
};
//# sourceMappingURL=MalarkeyToolbarUserMenu.es.js.map
